import { Box, styled } from '@mui/material';

export const CarouselHeaderStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}) as typeof Box;

export const SwiperWrapperStyled = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(4),
  div: {
    '&.swiper-slide': {
      height: 'auto',
    },
    '&.swiper': {
      width: '100%',
      height: 'auto',
    },
  },
}));
